export const dayOfWeek = [{
  id: 1,
  name: 'Monday'
}, {
  id: 2,
  name: 'Tuesday'
}, {
  id: 3,
  name: 'Wednesday'
}, {
  id: 4,
  name: 'Thursday'
}, {
  id: 5,
  name: 'Friday'
}, {
  id: 6,
  name: 'Saturday'
}, {
  id: 7,
  name: 'Sunday'
}]

export const mealType = [{
  id: 'breakfast',
  name: 'Breakfast'
}, {
  id: 'lunch',
  name: 'Lunch'
}, {
  id: 'snack',
  name: 'Snack'
}, {
  id: 'dinner',
  name: 'Dinner'}
]

export const genderOptions = [
  { id: 'male', name: 'male' },
  { id: 'female', name: 'female' }
]

export const statusOptions = [
  { id: 'pending', name: 'pending' },
  { id: 'approved', name: 'approved' },
  { id: 'rejected', name: 'rejected' }
]

export const userTypeOptions = [
  { id: 'teacher', name: 'teacher' },
  { id: 'admin', name: 'admin' },
  { id: 'student', name: 'student' },
  { id: 'individual', name: 'individual' }
]

export const teacherRoles = [
  {id: 'standard', name: 'Standard'},
  {id: 'advanced', name: 'Advanced'},
  {id: 'teacher admin', name: 'Teacher Admin'},
  {id: 'super admin', name: 'Super Admin'}
]

export const unitTypeOptions = [
  { id: 'metric', name: 'metric' },
  { id: 'imperial', name: 'imperial' }
]
